import { Component, OnInit } from '@angular/core';
import {RestaurantService} from "../../../modules/shared/services/restaurant.service";

@Component({
  selector: 'app-restaurant-selection',
  templateUrl: './restaurant-selection.component.html',
  styleUrls: ['./restaurant-selection.component.scss']
})
export class RestaurantSelectionComponent implements OnInit {

  constructor(
      private restaurantService: RestaurantService
  ) { }

  ngOnInit(): void {
  }

  get restaurants() {
    return this.restaurantService.allRestaurants;
  }

  get currentRestaurant() {
    return this.restaurantService.currentRestaurant;
  }

  changeRestaurant(id: number) {
    this.restaurantService.changeCurrentRestaurant(id, true);
  }
}
